









































































































import {Component, Watch} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import moment from "moment";
import {KretanjeVozila, PutniNalog, TrosakPuta} from "@/services/BackendProxies";
import dataProxy from "@/services/data-proxy.service";
import {formatDate, formatPrice, formatTime} from "@/utils/formatters";
import KretanjaPutnogNaloga from "@/views/PutniNalozi/PutniNalog/KretanjaPutnogNaloga.vue";
import TroskoviPutnogNaloga from "@/views/PutniNalozi/PutniNalog/TroskoviPutnogNaloga.vue";
import messages from "@/i18n/messages";

@Component({components: {'kretanja-putnog-naloga' : KretanjaPutnogNaloga, 'troskovi-putnog-naloga' : TroskoviPutnogNaloga}})
export default class UnosPutnogNaloga extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    putniNalog = PutniNalog.fromJS({datum: new Date(),
        kretanja: [KretanjeVozila.fromJS({datumPolaska: new Date()})],
        troskovi: [TrosakPuta.fromJS({datum: new Date()})]});

    zakljucan = 2;
    isBusy = false;
    pdfURL = '';

    async created() {
        this.load();
    }

    async load() {
        const putniNalogID = +this.$route.params["id"];
        if (putniNalogID) {
            const putniNalog = await this.loadData(() => dataProxy.vratiPutniNalogPoId(putniNalogID))();
            if (putniNalog.status == this.zakljucan) {
                this.showInfo('ovaj putni nalog je vec zakljucan i izmene nisu dozvoljene');
            }
            setTimeout(() => this.putniNalog = putniNalog, 500);
        } else {
            this.putniNalog = PutniNalog.fromJS({datum: new Date(),
                kretanja: [KretanjeVozila.fromJS({datumPolaska: new Date()})],
                troskovi: [TrosakPuta.fromJS({datum: new Date()})]});
        }
        this.$nextTick(() => {
            (<any>this.$refs.observer).validate();
        })
    }

    @Watch('$route') onRouteChange() {
        this.load();
    }

    obrisiKretanje(row) {
        this.putniNalog.kretanja = this.putniNalog.kretanja.filter(x => x != row);
    }

    obrisiTrosak(row) {
        this.putniNalog.troskovi = this.putniNalog.troskovi.filter(x => x != row);
    }

    async sacuvajPutniNalog() {
        if (this.putniNalog.status == this.zakljucan) {
            this.showInfo('ovaj putni nalog je vec zakljucan i izmene nisu dozvoljene');
            return;
        }
        if (this.isBusy) return;
        const valid = await (<any>this.$refs.observer).validate();
        if (valid) {
            this.validacije();
            try {
                this.isBusy = true;
                const putniNalog = PutniNalog.fromJS(this.putniNalog);
                putniNalog.kretanja.forEach(k => {
                   k.vremePolaska = formatTime(k.vremePolaska);
                   k.vremeDolaska = formatTime(k.vremeDolaska);
                });
                this.putniNalog = await this.saveData(() => dataProxy.sacuvajPutniNalog(putniNalog))();
            } finally {
                this.isBusy = false;
            }
        } else {
            this.showError('nisu sva obavezna polja popunjena');
        }
    }

    async zakljucajPutniNalog() {
        if (this.putniNalog.status == this.zakljucan) {
            this.showInfo('ovaj putni nalog je vec zakljucan i izmene nisu dozvoljene');
            return;
        }
        if (this.isBusy) return;
        const da = await this.confirmationNeeded('da li zelite da zakljucite putni nalog');
        if (da) {
            const valid = await (<any>this.$refs.observer).validate();
            if (valid) {
                this.validacije();
                try {
                    this.isBusy = true;
                    const putniNalog = PutniNalog.fromJS(this.putniNalog);
                    putniNalog.kretanja.forEach(k => {
                        k.vremePolaska = formatTime(k.vremePolaska);
                        k.vremeDolaska = formatTime(k.vremeDolaska);
                    });
                    this.putniNalog = await this.saveData(() => dataProxy.zakljuciPutniNalog(putniNalog))();
                    this.kreirajNoviNalog();
                } finally {
                    this.isBusy = false;
                }
            } else {
                this.showError('nisu sva obavezna polja popunjena');
            }
        }
    }

    validacije() {
        this.putniNalog.kretanja = this.putniNalog.kretanja.filter(
            x => x.datumPolaska && x.datumDolaska && x.vremePolaska && x.vremeDolaska && x.kilometrazaPolaska && x.kilometrazaDolaska);
        this.putniNalog.troskovi = this.putniNalog.troskovi.filter(x => x.trosakVozilaId && x.iznos);
    }

    get datumIVremePolaska() {
        const row = this.putniNalog.kretanja ? this.putniNalog.kretanja[0] : null;
        if (row) {
            return `${row.datumPolaska ? formatDate(row.datumPolaska) : ''}  ${row.vremePolaska ? formatTime(row.vremePolaska) : ''}`;
        }
    }

    get datumIVremeDolaska() {
        const index = this.putniNalog.kretanja.length ? this.putniNalog.kretanja.length - 1 : null;
        const row = this.putniNalog.kretanja[index];
        if (row) {
            return `${row.datumDolaska ? formatDate(row.datumDolaska) : ''} ${row.vremeDolaska ? formatTime(row.vremeDolaska) : ''}`;
        }
    }

    get ukupnoVreme() {
        const getDateTime = (date: Date, time: string) => {
            const d = moment(date);
            if (/^\d\d:\d\d:\d\d$/.test(time)) {
                const parts = time.split(':');
                d.set('hour', +parts[0]);
                d.set('minute', +parts[1]);
            } else {
                const t = moment(time);
                d.set('hour', t.get('hour'));
                d.set('minute', t.get('minute'));
            }
            return d;
        };
        let totalMinutes = 0;
        this.putniNalog.kretanja.forEach(kretanje => {
           const polazak = getDateTime(kretanje.datumPolaska, kretanje.vremePolaska);
           const dolazak = getDateTime(kretanje.datumDolaska, kretanje.vremeDolaska);
           const minutes = dolazak.diff(polazak, 'minutes');
           totalMinutes += !isNaN(minutes) ? minutes : 0;
        });
        const hours = Math.round(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        return `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
    }

    get ukupnoKM() {
        const firstRow = this.putniNalog.kretanja.length ? this.putniNalog.kretanja[0] : null;
        const lastRow = this.putniNalog.kretanja[this.putniNalog.kretanja.length - 1];
        if (firstRow) {
            if (lastRow.kilometrazaDolaska) {
                return `${lastRow.kilometrazaDolaska - firstRow.kilometrazaPolaska} km`
            } else {
                return `${lastRow.kilometrazaPolaska ? lastRow.kilometrazaPolaska - firstRow.kilometrazaPolaska : 0} km`
            }
        }
    }

    get ukupanTrosak() {
        let iznosi = [];
        for (let item of this.putniNalog.troskovi) {
            iznosi.push(parseInt(<any>item.iznos))
        }
        let result = iznosi.length >= 1 ? iznosi.reduce((a, b) => a + b) : 0;
        return formatPrice(result);
    }

    kreirajNoviNalog() {
        this.putniNalog = PutniNalog.fromJS({datum: new Date(),
            kretanja: [KretanjeVozila.fromJS({datumPolaska: new Date()})],
            troskovi: [TrosakPuta.fromJS({datum: new Date()})]});
        this.$router.replace('/putni-nalozi/unos-putnog-naloga');
    }

    async stampaj() {
        if (this.putniNalog.id) {
            try {
                const link = await this.loadData(() => dataProxy.vratiStampuPutnogNaloga(this.putniNalog.id))();
                this.pdfURL = `${link}?t=${new Date().getUTCMilliseconds()}`
            } finally {
            }
        }
    }
}
